import type { Ref, VideoHTMLAttributes } from 'react';
import styled from 'styled-components';

import { Video } from 'atoms/ui/Video';
import { breakpoints } from 'style/mediaQuery';

const VideoPlayer = styled(Video)`
  inset: 0;
  height: auto;
  width: 100%;
  object-fit: cover;
`;

interface Props extends VideoHTMLAttributes<HTMLVideoElement> {
  mobileSrc: string;
  ref?: Ref<HTMLVideoElement>;
}

export const BrandingVideo = ({ mobileSrc, src, ref, ...rest }: Props) => {
  return (
    <VideoPlayer
      ref={ref}
      width="1180px"
      playsInline
      controls
      sources={[
        {
          src,
        },
        {
          src: mobileSrc,
          media: `all and (max-width: ${breakpoints.tablet}px)`,
        },
      ]}
      {...rest}
    />
  );
};
